module.exports = __webpack_public_path__ + "static/img/88-3.81f3f6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/88-3.jpg
// module id = c97h
// module chunks = 0